$(document).ready(() => {
  initSelect2();
});

function initSelect2() {
  $('select:not(.no-search-select2)').select2({});

  $('select.no-search-select2').select2({
    minimumResultsForSearch: -1,
  });

  $('.allow_clear_select').select2({
    allowClear: true,
  });

  $('select').on(
    'select2:select select2:unselect select2:clear change.select2',
    (e) => {
      $(e.target)
        .next('.select2')
        .toggleClass('filled', e.target.value !== '');
    }
  );

  $('select').each((_, element) => {
    $(element)
      .next('.select2')
      .toggleClass('filled', element.value !== '');
  });
}
